<template>
  <div v-if="dialogStore.showHeader" class="dialog-step__header">
    <p-button
      v-if="!!props.hasBack"
      class="dialog-step__button mr-auto"
      icon="pi pi-arrow-left"
      @click="props.onBack"
    />
    <div
      v-else-if="!props.leftAlign"
      class="dialog-step__back-btn-placeholder"
    ></div>
    <span
      v-if="props.title"
      class="dialog-step__title dialog-step__title--position"
      :class="{
        'align-left': props.leftAlign,
      }"
      >{{ props.title }}</span
    >
    <div v-if="props.img" class="pln-0">
      <img
        src="@/assets/monitor-ipad.svg"
        alt="monitor and ipad header dialog icon"
      />
    </div>
    <div v-if="props.hasCloseButton">
      <p-button
        class="dialog-step__button ml-auto"
        icon="pi pi-times"
        @click="onClose"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from '@/store';
import { inject } from 'vue';

interface IProps {
  title: string;
  img?: boolean;
  hasBack?: boolean;
  hasCloseButton?: boolean;
  leftAlign?: boolean;
  onBack?(): void;
}

const dialogRef = inject('dialogRef');
const dialogStore = useDialogStore();

const props = defineProps<IProps>();
defineEmits(['close', 'back']);

const onClose = () => {
  dialogRef.value.close({ isCloseClicked: true });
};
</script>

<style scoped lang="scss">
.dialog-step__header {
  display: flex;
  align-items: center !important;
  padding-bottom: 0px;
  padding-top: 0px;
  min-height: 24px;
  width: 100%;
}
.dialog-step__title {
  box-sizing: border-box;
  font-weight: 600;
  font-size: 20px;
  color: var(--text-color);
}
.dialog-step__title--position {
  display: flex;
  flex: 3;
  justify-content: center;
}
.dialog-step__button {
  background: none;
  border: none;
  padding: 3px !important;
  color: rgba(212, 196, 237, 0.5) !important;
  flex: 0.1;
  &:hover {
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    color: rgba(255, 255, 255, 0.8) !important;
  }
}
.align-left {
  justify-content: flex-start;
}

.dialog-step__back-btn-placeholder {
  width: 22px;
}
.pln-0 {
  margin-left: -1.5rem;
}
</style>
